import { render, staticRenderFns } from "./DialogArchivesCard.vue?vue&type=template&id=c928c570&scoped=true&"
import script from "./DialogArchivesCard.vue?vue&type=script&lang=js&"
export * from "./DialogArchivesCard.vue?vue&type=script&lang=js&"
import style0 from "./DialogArchivesCard.vue?vue&type=style&index=0&id=c928c570&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c928c570",
  null
  
)

export default component.exports